<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
	.loading{width: 150px;height: 150px;top: 50%;left: 50%;transform: translate(-50%,-50%);border-radius: 6px;}
</style>



// WEBPACK FOOTER //
// src/App.vue